import React from "react"
import { Control, useController } from "react-hook-form"
import { components as selectComponents, InputProps, SingleValue } from "chakra-react-select"
import { getCountries } from "react-phone-number-input"
import en from "react-phone-number-input/locale/en.json"
import Select, { SelectOption } from "components/Select"

const countryOptions: SelectOption[] = getCountries()
  .map((code) => ({ label: en[code], value: en[code] }))
  .sort((a, b) => a.label.localeCompare(b.label))

// Chrome ignores autocomplete="off" on fields it recognizes as an address and
// pops its native autofill over the menu; "new-password" suppresses it
const Input = (props: InputProps<SelectOption, false>) => (
  <selectComponents.Input {...props} autoComplete="new-password" />
)

type Props = {
  name: string
  control: Control<any>
}

const CountrySelect = ({ name, control }: Props) => {
  const { field } = useController({ name, control })
  // Fall back to a synthetic option so pre-dropdown free-text values still display
  const selectedItem = field.value
    ? countryOptions.find(({ value }) => value === field.value)
      ?? { label: field.value, value: field.value }
    : null

  return (
    <Select<SelectOption, false>
      value={selectedItem}
      name={name}
      options={countryOptions}
      placeholder="Country"
      aria-label="Country"
      variant="flushed"
      isClearable
      menuPlacement="auto"
      components={{ Input }}
      onChange={(option: SingleValue<SelectOption>) => field.onChange(option?.value ?? "")}
    />
  )
}

export default CountrySelect
